import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListForReorderItemsModule } from '@shared/core/components/lists/listsTypes/forReorderItems';

import { ReorderWizzardComponent } from './reorder-wizzard.shared.component';

@NgModule({
    declarations: [
        ReorderWizzardComponent
    ],
    imports: [
        CommonModule,
        ListForReorderItemsModule,
    ],
    exports: [
        ReorderWizzardComponent,
    ],
})
export class ReorderWizzardModule { }
